import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="flex min-h-[60vh] items-center justify-center bg-background px-4">
      <div className="text-center">
        <h1 className="display-title text-7xl text-brand">404</h1>
        <p className="mt-2 font-condensed text-2xl uppercase">Page not found</p>
        <Link to="/" className="mt-6 inline-flex items-center rounded-md bg-brand px-6 py-3 text-sm font-semibold uppercase text-white">Back Home</Link>
      </div>
    </section>
  );
}
